export { default } from './FontSizeSlider';
